import { ReactNode } from 'react'

import { Box, CircularProgress } from '@material-ui/core'

import LoadingBubbles from 'components/LoadingBubbles'

const defaultText = 'Integrations Page is loading'

type LoadingProps = {
  loadingText?: string
  isLoading: boolean
  loadingBubbles?: boolean
  children: ReactNode
}

const Loading = ({ loadingText = defaultText, isLoading, loadingBubbles, children }: LoadingProps) => {
  return isLoading ? (
    <Box
      display="flex"
      justifyContent="center"
    >
      {loadingBubbles ? (
        <LoadingBubbles altText={loadingText} />
      ) : (
        <Box mt={10}>
          <CircularProgress
            role="status"
            aria-label={loadingText}
          />
        </Box>
      )}
    </Box>
  ) : (
    <>{children}</>
  )
}

export default Loading
